import { defaultValue, SternumTheme } from '@sternum/ui';

import { Colors } from '../constants';

export const lightTheme: SternumTheme = {
  ...defaultValue,
  primary: Colors.BrandPink,
  secondary: Colors.BrandBlue,
  focusColor: Colors.AquaMiddle,
  textColor: Colors.Darkest,
  fontFamily: 'Fellix, Arial, Helvetica, sans-serif',
};
